import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';
import {
  EmailConfigDTO,
  EmailConfigList,
  EmailConfigCreateRequestDTO,
  EmailConfigUpdateRequestDTO,
  EmailConfigDeleteRequestDTO,
  EmailConfigReadByIdRequestDTO,
  EmailConfigReadAllPaginatedRequestDTO,
  EmailConfigReadAllRequestDTO,
  EmailConfigUpdatePasswordRequestDTO
} from './email-config.interface';
import {
  EmailConfig_create,
  EmailConfig_update,
  EmailConfig_delete,
  EmailConfig_readById,
  EmailConfig_readAll,
  EmailConfig_ReadAllPaginated,
  EmailConfig_updatePassword
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class EmailConfigService {
  constructor(private http: HttpClient) {}

  EmailConfig_create(data: EmailConfigCreateRequestDTO): Observable<EmailConfigDTO> {
    return this.http.post<EmailConfigDTO>(EmailConfig_create, data);
  }

  EmailConfig_update(data: EmailConfigUpdateRequestDTO): Observable<EmailConfigDTO> {
    return this.http.post<EmailConfigDTO>(EmailConfig_update, data);
  }

  EmailConfig_delete(data: EmailConfigDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(EmailConfig_delete, data);
  }

  EmailConfig_readById(data: EmailConfigReadByIdRequestDTO): Observable<EmailConfigDTO> {
    return this.http.post<EmailConfigDTO>(EmailConfig_readById, data);
  }

  // baseUrlOverride (optional): the viewed tenant's own NT gateway origin,
  // e.g. CompanyDetailComponent.apiConfigOverride.NT. Omitted for every
  // other caller - behaves exactly as before.
  EmailConfig_readAll(data: EmailConfigReadAllRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<EmailConfigList> {
    return this.http.post<EmailConfigList>(resolveTenantUrl(EmailConfig_readAll, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
  }


  EmailConfig_ReadAllPaginated(data: EmailConfigReadAllPaginatedRequestDTO): Observable<EmailConfigList> {
    return this.http.post<EmailConfigList>(EmailConfig_ReadAllPaginated, data);
  }
  EmailConfig_updatePassword(data: EmailConfigUpdatePasswordRequestDTO): Observable<void> {
    return this.http.post<void>(EmailConfig_updatePassword, data);
  }

}
